<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-card-title>Места</v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-radio-group :value="fields.seating.enabled" :disabled="loading || isOnlyEdit">
        <v-radio :label="'Без мест'" :value="false" @click="toggleSeatingType(false)" />

        <v-radio :label="'Вручную'" :value="true" @click="toggleSeatingType(true)" />
      </v-radio-group>
    </v-row>
    <v-row v-if="fields.seating.enabled">
      <v-col cols="12">
        <span>Название *</span>
        <v-text-field outlined :disabled="loading || isOnlyEdit" v-model="fields.seating.name" />
      </v-col>
    </v-row>
    <v-row>
      <template v-if="fields.seating.enabled && fields.seating.zones.length">
        <v-card
          v-for="(seatZone, seatZoneIndex) in fields.seating.zones"
          :key="seatZoneIndex"
          width="100%"
          class="mb-5"
          outlined
        >
          <v-container>
            <v-row>
              <v-col cols="11">
                <v-card-title>Зона "{{ seatZone.title }}"</v-card-title>
              </v-col>
              <v-col cols="1" class="d-flex justify-center align-center">
                <v-btn icon :disabled="loading || isOnlyEdit" :loading="loading" @click="deleteSeatZone(seatZone.id, seatZoneIndex)">
                  <v-icon color="red">mdi-trash-can-outline</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span>Название</span>
                <v-text-field outlined :disabled="loading || isOnlyEdit" v-model="seatZone.title" />
              </v-col>
            </v-row>

            <v-row v-if="fields.seating.enabled && fields.seating.zones.length">
              <v-col cols="12">
                <PlaceZoneBuilder
                  :is-loading="loading"
                  :is-only-edit="isOnlyEdit"
                  :seat-rows-list="seatZone.rows"
                  @duplicate-seat-row="duplicateSeatRow($event, seatZoneIndex)"
                  @remove-seat-row="deleteSeatRow($event, seatZoneIndex)"
                  @create-seat-row="createSeatRows($event, seatZoneIndex)"
                  @remove-seat="deleteSeat($event, seatZoneIndex)"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          v-if="fields.seating.enabled"
          class="mt-10"
          :disabled="loading || isOnlyEdit"
          :loading="loading"
          @click="createSeatZone"
          >Добавить зону</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormAbstract from '@/components/abstract/form'
import PlaceZoneBuilder from '@/components/event/places/builder'

class SeatZone {
  // id = null
  title = ''
  rows = []
}

class Row {
  // id = null
  title = null
  seats = []

  constructor (title, seats = null) {
    this.title = title
    if (seats) {
      this.seats = seats
    }
  }
}

class Seat {
  // id = null
  number = null

  constructor (number) {
    this.number = number
  }
}
export default {
  extends: FormAbstract,
  name: 'FormEventPlaces',
  props: {
    data: {
      type: [Array, Object],
      default: null
    },
    eventId: {
      type: [Number, null],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PlaceZoneBuilder
  },
  data () {
    return {
      fields: {
        seating: {
          zones: [],
          name: null,
          enabled: false,
          eventId: null
        }
      }
    }
  },
  computed: {
    returnSeating () {
      return this.fields?.seating || null
    }
  },
  watch: {
    data (newVal) {
      if (newVal !== null) {
        this.fields.seating = newVal
      }
    },
    returnSeating: {
      deep: true,
      handler (newVal) {
        this.$emit('seating', newVal)
      }
    }
  },
  methods: {
    getCurrentSeatZone (seatZoneIndex) {
      return this.fields.seating.zones[seatZoneIndex]
    },
    createSeatZone () {
      this.fields.seating.zones.push(new SeatZone())
    },
    createSeatRows ({ number, rowTitle }, seatZoneIndex) {
      const currentSeatZone = this.getCurrentSeatZone(seatZoneIndex)
      number.forEach(seatNumber => {
        const newSeat = new Seat(seatNumber)
        const currentRowIndex = currentSeatZone.rows.findIndex(
          row => row.title === rowTitle
        )
        if (currentRowIndex >= 0) {
          currentSeatZone.rows[currentRowIndex].seats.push(newSeat)
        } else {
          currentSeatZone.rows.push(new Row(rowTitle, [newSeat]))
        }
      })
    },
    duplicateSeatRow (index, seatZoneIndex) {
      const currentSeatZone = this.getCurrentSeatZone(seatZoneIndex)
      const currentRow = { ...currentSeatZone.rows[index] }
      delete currentRow.id
      const newRow = new Row(
        currentRow.title,
        currentRow.seats.map(s => new Seat(s.number))
      )
      currentSeatZone.rows.push(newRow)
    },
    deleteSeatRow ({ id, index }, seatZoneIndex) {
      const currentSeatZone = this.getCurrentSeatZone(seatZoneIndex)
      if (id) {
        this.$emit('delete-seat-row', id)
      }
      currentSeatZone.rows.splice(index, 1)
    },
    toggleSeatingType (value) {
      this.fields.seating.zones = []
      this.fields.seating.name = ''
      this.fields.seating.enabled = value
    },
    deleteSeatZone (id, index) {
      if (id) {
        this.$emit('delete-seat-zone', id)
      }
      this.fields.seating.zones.splice(index, 1)
    },
    deleteSeat ({ id, index, seatRowIndex }, seatZoneIndex) {
      const currentSeatZone = this.getCurrentSeatZone(seatZoneIndex)
      if (id) {
        this.$emit('delete-seat', id)
      }
      currentSeatZone.rows[seatRowIndex].seats.splice(index, 1)
    }
  },
  async: {},
  created () {
    if (this.data !== null) {
      this.fields.seating = this.data
    }
  }
}
</script>
